import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const ThreadPageInfo = styled.div`
  margin: 5px 0 20px 0;
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.wfGrey900};
  vertical-align: -webkit-baseline-middle;
  ${media.s`
    line-height: 1.4;
    margin: 0 0 15px 0;
  `};
`;

export const CategoryName = styled.span`
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.color || '#727272'};
  &:hover {
    text-decoration: underline;
  }
`;
